import React, { useEffect } from 'react';
import { AuthProvider } from './components/AuthContext';
import AppRouter from './AppRouter';
import { initGA } from './utils/analytics';
import { initializeRedditPixel } from './utils/redditPixel';
import { HelmetProvider } from 'react-helmet-async';

const App = () => {
  useEffect(() => {
    initGA()
    initializeRedditPixel();
  }, [])

  return (
    <HelmetProvider>
      <AuthProvider>
        <AppRouter />
      </AuthProvider>
    </HelmetProvider>
  );
};

export default App;